import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { AmorphicService } from '../../../../../coverpath-common/angular/services/amorphic/amorphic.service';

@Component({
    moduleId: module.id,
    selector: 'home',
    templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit {
    private token: string;
    private email: string;
    controller;
    appSubmitted: boolean = false;
    private loggedIn: boolean = false;

    constructor(private amorphicService: AmorphicService, private route: ActivatedRoute, protected router: Router) {
        this.controller = amorphicService.controller;
    }

    ngOnInit(): void {
        this.route.fragment
            .subscribe(fragment => {
                if (fragment === "verify_email_change") {
                }
                else if (fragment === "reset_password_from_code") {
                    this.router.navigate(['login'], {queryParams: {reset_password: true}, fragment: 'Reset'});
                }
                else if (fragment === "login") {
                    this.router.navigate(['login']);
                }
                else if (fragment === "register") {
                    this.router.navigate(['login'], {fragment: 'Register'});
                }
                else if (fragment === "faq") {
                    this.router.navigate(['faq']);
                }
            });

        this.route.queryParams
            .subscribe(param => {
                if (param.token) {
                    this.token = param.token;
                    this.email = param.email;
                    this.setPasswordChangeHash();
                } else if (param.code) {
                    this.controller.verifyEmailCode = param.code;
                    this.controller.email = param.email;
                    this.router.navigate(['login'], {fragment: 'NewEmail'});
                }
        });

        this.appSubmitted = this.controller.isApplicationSubmitted();
        this.loggedIn = this.controller.loggedIn;

        if (this.appSubmitted) {
            this.router.navigate(['account-center']);
        } else if (this.loggedIn) {
            this.router.navigate(['application-form']);
        }
    }

    setPasswordChangeHash(): void {
        this.controller.passwordChangeHash = this.token;
        this.controller.email = this.email;
        this.controller.publicSave();
    }

}
